import React from 'react';
import { Container, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { styled } from '@mui/system';

const Root = styled(Container)(({ theme }) => ({
  textAlign: 'center',
  padding: theme.spacing(4),
  marginTop: theme.spacing(8),
}));

const ErrorMessage = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  fontSize: '2rem',
  fontWeight: 'bold',
}));

const ErrorDescription = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(4),
  color: theme.palette.text.secondary,
}));

const NotFoundPage = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <Root>
      <ErrorMessage variant="h1">Błąd 404</ErrorMessage>
      <ErrorDescription variant="h6">Strona nie została znaleziona</ErrorDescription>
      <Button variant="contained" color="primary" onClick={handleGoHome}>
        Wróć na stronę główną
      </Button>
    </Root>
  );
};

export default NotFoundPage;